if (!customElements.get('sotto-trust-bar')) {
  customElements.define(
    'sotto-trust-bar',
    class SottoTrustBar extends HTMLElement {
      connectedCallback() {
        if (this.dataset.mobileLayout !== 'slider') return;

        this.items = Array.from(this.querySelectorAll('.sotto-trust-bar__item'));
        if (this.items.length < 2) return;

        this.interval = parseInt(this.dataset.interval, 10) || 3000;
        this.autoplay = this.dataset.autoplay !== 'false';
        this.index = 0;
        this.mediaQuery = window.matchMedia('(max-width: 749px)');

        this.onBreakpointChange = () => this.evaluate();
        this.mediaQuery.addEventListener('change', this.onBreakpointChange);

        // Pause on interaction so a shopper can read a slide.
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.evaluate());
        this.addEventListener('touchstart', () => this.stop(), { passive: true });

        this.evaluate();
      }

      disconnectedCallback() {
        this.stop();
        if (this.mediaQuery) this.mediaQuery.removeEventListener('change', this.onBreakpointChange);
      }

      evaluate() {
        if (this.mediaQuery.matches && this.autoplay) {
          this.start();
        } else {
          this.stop();
        }
      }

      start() {
        if (this.timer) return;
        this.show(this.index);
        this.timer = setInterval(() => {
          this.index = (this.index + 1) % this.items.length;
          this.show(this.index);
        }, this.interval);
      }

      stop() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }

      show(activeIndex) {
        this.items.forEach((item, index) => {
          item.classList.toggle('is-active', index === activeIndex);
        });
      }
    }
  );
}
